// src/i18n/index.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 直接导入翻译文件（无需 public 目录）
import zhTranslation from "./locales/zh/translation.json";
import enTranslation from "./locales/en/translation.json";
import zhTWTranslation from "./locales/zh-TW/translation.json";

// 定义：更新html语言类名的函数
const updateHtmlLangClass = (lng) => {
  // 移除所有旧的语言类名
  document.documentElement.classList.remove(
    "lang-zh-cn",
    "lang-zh-tw",
    "lang-en"
  );
  // 根据当前语言添加对应类名（统一转为小写，兼容不同格式）
  const langClass = `lang-${lng.toLowerCase().replace(/[-_]/, "-")}`;
  document.documentElement.classList.add(langClass);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "zh",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    // 直接配置翻译内容
    resources: {
      zh: {
        translation: zhTranslation,
      },
      en: {
        translation: enTranslation,
      },
      "zh-TW": { translation: zhTWTranslation }, // 新增繁中
    },
    supportedLngs: ["zh", "en", "zh-TW"],
  })
  .then(() => {
    // 初始化完成后，设置初始语言类名
    updateHtmlLangClass(i18n.language);
  });
// 监听语言切换事件，同步更新类名
i18n.on("languageChanged", (lng) => {
  updateHtmlLangClass(lng);
});
export default i18n;
